export enum PermissionRoles {
  GG_RO_HQ_SHOP_RECEPTION_ADMIN = 'GG_RO_HQ_SHOP_RECEPTION_ADMIN',
  GG_RO_HQ_SHOP_RECEPTION_STORE = 'GG_RO_HQ_SHOP_RECEPTION_STORE',
  GG_RO_HQ_SHOP_RECEPTION_BACKOFFICE = 'GG_RO_HQ_SHOP_RECEPTION_BACKOFFICE',
  GG_RO_HQ_SHOP_RECEPTION_HUB = 'GG_RO_HQ_SHOP_RECEPTION_HUB',
  GG_RO_HQ_SHOP_RECEPTION_WAREHOUSE = 'GG_RO_HQ_SHOP_RECEPTION_WAREHOUSE',
  GG_RO_HQ_SHOP_RECEPTION_AMBALAJE = 'GG_RO_HQ_SHOP_RECEPTION_AMBALAJE',
  GG_RO_HQ_SHOP_RECEPTION_RETURO = 'GG_RO_HQ_SHOP_RECEPTION_RETURO',
  GG_RO_DEX_WMP_USER = 'GG_RO_DEX_WMP_USER'
}

export const SHOP_RECEPTION_FETCH_SHOP_ROLES = [
  PermissionRoles.GG_RO_HQ_SHOP_RECEPTION_STORE,
  PermissionRoles.GG_RO_HQ_SHOP_RECEPTION_BACKOFFICE,
  PermissionRoles.GG_RO_HQ_SHOP_RECEPTION_RETURO
]

export const SHOP_RECEPTION_FETCH_HUB_ROLES = [PermissionRoles.GG_RO_HQ_SHOP_RECEPTION_HUB]

export const SHOP_RECEPTION_FETCH_WAREHOUSE_ROLES = [
  PermissionRoles.GG_RO_HQ_SHOP_RECEPTION_WAREHOUSE,
  PermissionRoles.GG_RO_HQ_SHOP_RECEPTION_AMBALAJE
]

export const WMS_FETCH_MISSING_DAILY_REPORTS_ROLES = [PermissionRoles.GG_RO_DEX_WMP_USER]

export const SHOP = 'shop'
export const HUB = 'hub'
export const WAREHOUSE = 'warehouse'
